export { default } from "./PaymentCreditsV2Mspa";
